// extracted by mini-css-extract-plugin
export default {"cell":"tableCell_cell__FMEwK"};